export class FontEntity {
  constructor(
    public readonly name: string,
    public readonly fontFamily: string,
    public readonly fontFamilyBold: string,
    public readonly buttonFontFamily: string,
  ) {}
}
